import { combineReducers } from 'redux';
import activate from './activate';
import list from './list';

export default combineReducers({
  list,
  activate
});
